/*
 * $Id:: index.js 2021/03/02 01:38 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { NOTIFICATIONS_SLICE_NAME } from '../../../app/constants';
import PageTitle from '../../../components/PageTitle';
import { t } from '../../../providers';
import { requestResult as resultSlice, loading as loadingSlice, error as errorSlice } from '../accountSlice';
import ChildAccountCard from '../components/ChildAccountCard';
import { SLICE_NAME } from '../constants';

const useStyles = makeStyles(() => ({
    container: {
        height: '100%',
        padding: '4rem 4rem 0',
        maxWidth: '653px',
        '@media (max-width:600px)': {
            padding: '4rem 1rem 0',
        },
    },
    tabs: {
        marginBottom: '20px',
    },
    tabContainer: {
        width: '100%',
    },
    cardContainer: {
        '@media (min-width:1100px)': {
            width: '653px',
        },
    },
}));

const CreateChildAccount = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const response = useSelector(resultSlice);
    const loading = useSelector(loadingSlice);
    const error = useSelector(errorSlice);
    const history = useHistory();

    useEffect(() => {
        if (response && response.ok) {
            dispatch({ type: `${SLICE_NAME}/requestResult`, payload: null });
            const notification = { message: t('child.account.added') };
            dispatch({ type: `${NOTIFICATIONS_SLICE_NAME}/addNotification`, payload: notification });
            history.push('/my-account/child-accounts');
        }
    }, [response, dispatch, history]);

    const saveAccount = (payload) => {
        dispatch({ type: `${SLICE_NAME}/createChildAccount`, payload });
    };

    const cancelAction = () => {
        history.push('/my-account/child-accounts');
    };

    return (
        <div className={classes.container}>
            <PageTitle title={t('add.new.child.account')} details={t('add.new.child.account.description')} />
            <div className={classes.cardContainer}>
                {loading ? <CircularProgress /> : <ChildAccountCard saveAccount={saveAccount} cancelAction={cancelAction} error={error} />}
            </div>
        </div>
    );
};

export default CreateChildAccount;
